/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_How_ScoredInputs */

const en_directory_hubs_signals_how_scored = /** @type {(inputs: Directory_Hubs_Signals_How_ScoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How the score is calculated`)
};

const zh_directory_hubs_signals_how_scored = /** @type {(inputs: Directory_Hubs_Signals_How_ScoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评分如何计算`)
};

/**
* | output |
* | --- |
* | "How the score is calculated" |
*
* @param {Directory_Hubs_Signals_How_ScoredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_how_scored = /** @type {((inputs?: Directory_Hubs_Signals_How_ScoredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_How_ScoredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_how_scored(inputs)
	return zh_directory_hubs_signals_how_scored(inputs)
});
export { directory_hubs_signals_how_scored as "directory.hubs.signals.how_scored" }